import React, { useEffect, useRef } from "react";
import "./braceletsShop.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Bracelet_1 from "./images/bracelet_1.webp";
import Bracelet_2 from "./images/bracelet_2.webp";
import Bracelet_3 from "./images/bracelet_3.webp";
import Bracelet_4 from "./images/bracelet_4.webp";
import Bracelet_5 from "./images/bracelet_5.webp";
import ShopIcon from "../../../images/shop.svg";
import Video1 from "./images/video_1.mp4";

export default function BraceletsShop() {
  return (
    <div className="braceletsShop-main">
      <div className="braceletsShop-container">
        <video
          playsinline="true"
          autoplay="true"
          loop="true"
          muted="true"
          className="braceletsShop-element braceletsShop-video"
        >
          <source
            src={
              "https://cdn.media.amplience.net/v/teilor/natalia bratara diamante/mp4_720p"
            }
            type="video/mp4"
          />
        </video>
        <div className="braceletsShop-element braceletsShop-product-1">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/bransoletka-z-bialego-zlota-18k-z-diamentami-8-36ct-108308.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/bransoletka-z-biaego-zota-18k-z-diamentami-836ct_3111837_1_1653919973.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="braceletsShop-element braceletsShop-product-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/bransoletka-z-bialego-zlota-18k-z-diamentami-4-25ct-122804.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/bransoletka-z-biaego-zota-18k-z-diamentami-425ct_3115741_1_1653919973.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="braceletsShop-element braceletsShop-product-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/bransoletka-tenisowa-z-bialego-zlota-18-karatowego-z-przezroczystymi-diamentami-1-45ct-i-czarnymi-diamentami-9-2ct-104443.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/bransoletka-tenisowa-z-biaego-zota-18karatowego-z-przezroczystymi-diamentami-145ct-i-czarnymi-diamentami-92ct_2486033_1_1653919974.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="braceletsShop-element braceletsShop-product-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/bransoletka-z-bialego-zlota-18-karatowego-z-szafirami-4-4-karatowymi-i-diamentami-1-67-karatowymi-123553.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/bransoletka-z-biaego-zota-18karatowego-z-szafirami-44karatowymi-i-diamentami-167karatowymi_3099753_1_1653919973.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
        <div className="braceletsShop-element braceletsShop-product-5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/bransoletka-z-czarno-bialego-zlota-18-karatowego-z-przezroczystymi-diamentami-15-3ct-i-11-karatowymi-czarnymi-diamentami-124333.html"
          >
            <img
              className="zoom"
              alt=""
              src={
                "https://cdn1.teilor.pl/slir/w700//teilor.pl/cs-content/cs-photos/products/original/bransoletka-z-czarnobiaego-zota-18karatowego-z-przezroczystymi-diamentami-153ct-i-11karatowymi-czarnymi-diamentami_3109388_1_1653919979.png"
              }
            />
            <img className="shop-icon" alt="" src={ShopIcon} />
          </a>
        </div>
      </div>
      <div className="component-button">
        <div className="component-button-border" />
        <div className="component-button-text">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.pl/pure-diamonds/filtre/rodzaj-bizuterii-bransoletka/rodzaj-bizuterii-bransoletka-tenisowe/rodzaj-bizuterii-bransoletka-tennis.html"
          >
            ODKRYJ BRANSOLETKI
          </a>
        </div>
      </div>
    </div>
  );
}
